import 'regenerator-runtime/runtime'

import React from 'react'
import {render} from 'react-dom'
import {Provider} from 'react-redux'
import {Router, Route} from 'react-router-dom'
import {globalJss} from 'rambler-ui'
import {sentryReact as Sentry} from '@rambler-id/sentry'
import history from 'utils/history'
import {SENTRY_DSN, SENTRY_IGNORE_ERROR} from 'utils/constants'
import App from 'containers/App'
import configureStore from './configureStore'
import './styles.css'
import {createDebug, activateDebug} from '@rambler-id/debug'

const debug = createDebug('id:account')

activateDebug()

debug(process.env.VERSION)

globalJss.setup({insertionPoint: 'jss-insertion-point'})

Sentry.init({
  dsn: SENTRY_DSN,
  sampleRate: 0.1,
  release: process.env.VERSION,
  environment: process.env.NODE_ENV,
  tags: {
    commit: process.env.COMMIT
  },
  whitelistUrls: [/https?:\/\/id\.rambler\.ru\/account\//],
  beforeSend: (event, hint) => {
    const {message, code} =
      hint && hint.originalException ? hint.originalException : {}

    if (
      ~SENTRY_IGNORE_ERROR.indexOf(message) ||
      ~SENTRY_IGNORE_ERROR.indexOf(code)
    ) {
      return null
    }

    return event
  }
})

const store = configureStore()

render(
  <Provider store={store}>
    <Router history={history}>
      <Route path="/account" render={(props) => <App {...props} />} />
    </Router>
  </Provider>,
  document.getElementById('root')
)
